<!-- src/components/modal/DailyNoticeModal.vue -->
<template>
  <div class="page-popup">
    <div
      v-show="isActive && dailyNoticeContent"
      class="popup-wrap daily-notice"
      :class="{ active: isActive && dailyNoticeContent }"
    >
      <div class="popup-box">
        <div class="popup-page">
          <!--eslint-disable-next-line-->
          <p class="h5 nl2br" v-html="dailyNoticeContent" />
          <div class="modal-footer">
            <span v-if="dailyNoticeData && dailyNoticeData.setting.url" class="modal-button" @click="hideModal">
              詳しくはこちらをクリック！
            </span>
            <span v-else class="modal-button" @click="hideModal">
              {{ $t('Bao.close') }}
            </span>
          </div>
        </div>
        <a class="popup-close" @click="hideModal" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DailyNoticeModal',
  props: {
    isActive: Boolean,
    dailyNoticeData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['user']),
    dailyNoticeContent() {
      return this.isActive && this.dailyNoticeData.content ? this.dailyNoticeData.content : ''
    }
  },
  methods: {
    hideModal() {
      if (this.dailyNoticeData.setting.url) {
        window.location.href = this.dailyNoticeData.setting.url
      }
      this.$emit('hideModal')
    }
  }
}
</script>

<style scoped>
.nl2br {
  white-space: pre-line;
  line-height: 1.2;
}
.modal-footer {
  display: flex;
  justify-content: center;
  padding: 10px;
}

.modal-button {
  float: right;
  white-space: initial;
  padding: 10px 20px;
  border-radius: 5px;
  color: #978564;
  background: transparent;
  border: 1px solid #978564;
  transition: background-color 0.3s ease;
}

.modal-button:hover {
  background: #b1a781;
  border: 1px solid #b1a781;
  color: #fff;
}
</style>
